// extracted by mini-css-extract-plugin
export default {"sortIcon":"SortIcon_sortIcon__7W0Pg","sortIconRotated":"SortIcon_sortIconRotated__r272C"};